<template>
  <div class="texts-select-input clearfix">
    <div class="form-group row">
      <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <select class="form-control" ref="dropdown" multiple
        :name="options.name+'[]'" @change="validate()">
          <option v-for="(val, i) in options.existing"
            :key="i"
            :value="val"
            :checked="val === value">{{ val }}</option>
        </select>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import Choices from 'choices.js'
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'TextsSelectInput',
  props: {
    value: {
      type: Array
    },
    options: {
      type: Object,
      default () {
        return {
          label: 'Text',
          name: 'texts-select',
          existing: [],
          valid: false,
          dirty: false,
          required: false
        }
      }
    }
  },
  data () {
    return {
      isDirty: false,
      isValid: false,
      currentResults: false,
      choices: false
    }
  },
  computed: {
    label () {
      return this.options.singleLabel
        ? this.options.singleLabel
        : this.options.label
    },
    validationClass,
    validationIcon,
    validationMessage,
    invalidMessage () {
      if (this.options.required) {
        return this.options.label + ' is required'
      } else {
        return 'Invalid value'
      }
    }
  },
  mounted () {
    let $vm = this
    /* eslint-disable no-new */
    this.choices = new Choices(this.$refs.dropdown, {
      placeholderValue: 'Enter a ' + this.options.label,
      noResultsText: 'Press enter to add a new value',
      itemSelectText: '',
      removeItemButton: true,
      fuseOptions: {
        threshold: 0
      },
      callbackOnInit: function () {
        if (!$vm.value) {
          let el = this.store.getItemsFilteredByActive().pop()
          if (el) this.removeItemsByValue(el.value)
        } else {
          this.setValueByChoice($vm.value)
        }
      }
    })
    // add custom adding items behaviour
    this.$refs.dropdown.addEventListener('search', (event) => {
      this.currentResults = !this.choices.choiceList.innerHTML.includes('Press enter to add a new value')
      this.choices.input.addEventListener('keydown', this.addSearchValue)
    })
    // fix bug that causes dropdown to continually close until a key event is detected
    this.$refs.dropdown.addEventListener('showDropdown', (event) => {
      this.choices.clearInput()
      this.$nextTick(function () {
        var e = new window.Event('keydown', {
          'bubbles': true
        })
        e.key = 'a'
        e.keyCode = e.key.charCodeAt(0)
        e.which = e.keyCode
        e.altKey = false
        e.ctrlKey = true
        e.shiftKey = false
        e.metaKey = false
        this.choices.input.dispatchEvent(e)
        this.choices.input.focus()
      })
    })
    this.validate()
  },
  methods: {
    async validate (val) {
      await this.$nextTick()
      let data = false
      if (!val) {
        data = this.choices.getValue()
        val = data.map(el => el.value)
      }
      this.$emit('input', val)
      if (this.options.required && val) {
        this.isDirty = true
        this.isValid = val.length > 0
      } else if (this.options.required && !val) {
        this.isValid = false
      } else {
        this.isValid = true
      }
    },
    async addSearchValue (e) {
      // check if enter key is pressed, then add value
      let key = e.which || e.keyCode
      if (key === 13 && !this.currentResults) {
        this.validate(this.choices.currentValue)
        this.choices.setValue([this.choices.currentValue])
        await this.$nextTick()
        this.choices.input.value = ''
        this.validate()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/TextsSelectInput.vue